import CityPageTemplate from "@/pages/oregon-city/CityPageTemplate";
import { troutdaleConfig } from "./data";

export default function TroutdalePage() {
  return <CityPageTemplate config={troutdaleConfig} />;
}